
<template>
  <div class="ev-calculator-section">
    <div>
      <div class="section-title">Integrated exposure calculator</div>
      <div class="section-paragraph">
        You mount an ND filter on your lens and wonder how you have to change the exposure settings?
        With the Camoodoo selection dialogs this is very easy to answer.
        The relative exposure change is shown on the left side. The correct value can thus be found easily.
      </div>
    </div>
    <q-img class="image" src="images/ev_calc_title.jpg" contain />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.ev-calculator-section {
  display: grid;
  grid-template-columns: 3fr 2fr;
  align-items: center;
  justify-items: center;
  grid-gap: var(--content-margin);
  padding: var(--section-padding);
}

.image {
  max-height: 300pt;
}
</style>
